<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseIds">
              <Select v-model="pageParams.ymsWarehouseIds" filterable multiple>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002400')" prop="code">
              <Input :placeholder="$t('key1002401')" clearable v-model.trim="pageParams.code"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002201')" prop="ymsContainerTypeId">
              <Select v-model="pageParams.ymsContainerTypeId" filterable>
                <Option v-for="item in containerTypeList" :key="item.ymsContainerTypeId" :value="item.ymsContainerTypeId">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002402')" prop="colorNameList">
              <Select v-model="pageParams.colorNameList" filterable multiple>
                <Option v-for="(item,index) in containerColorList" :key="index" :value="item">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002403')" prop="status">
              <Select v-model="pageParams.status" filterable>
                <Option v-for="(item,index) in jobStatusList" :key="index" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" @click="openContainer"
        v-if="getPermission('ymsContainer_batchInsert')">{{ $t('key1001340') }}</Button>
      <Button class="mr15" type="primary" @click="batchDeleteBtn"
        v-if="getPermission('ymsContainer_batchDelete')">{{ $t('key1002406') }}</Button>
      <Button class="mr15" type="primary" @click="printContainerBtn"
        v-if="getPermission('ymsContainer_batchPrintContainer')">{{ $t('key1002240') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        @on-sort-change="sortChange"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增容器弹窗-->
    <Modal v-model="containerModal" :title="containerTitle" width="500" @on-visible-change="containerChange"
      :transfer="false" :mask-closable="false" class-name="containerModalStyle">
      <Form ref="containerModalForm" :model="containerModalForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
        <Row style="width: 90%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="!editColorTalg">
            <Form-item :label="$t('key1002404')" prop="ymsContainerCount">
              <InputNumber :max="1000" :min="1" v-model="containerModalForm.ymsContainerCount" style="width: 100%;"></InputNumber>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="!editColorTalg">
            <Form-item :label="$t('key1002201')" prop="ymsContainerTypeId">
              <Select v-model="containerModalForm.ymsContainerTypeId" filterable transfer>
                <Option v-for="(item, index) in containerTypeList" :value="item.ymsContainerTypeId" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002402')" prop="colorName" :class="editColorTalg ? 'reset_label_style' : ''">
              <div class="flex justify-content-between">
                <ColorPicker class="cursor" v-model="containerModalForm.colorCode" recommend/>
                <Input :placeholder="$t('key1002405')" class="mr10 ml10" style="width: 120px;" v-model.trim="containerModalForm.colorName"></Input>
                <div class="upload_audio_box">
                  <Upload
                    style="display: inline-block;"
                    :headers="headObj"
                    ref="uploadRef"
                    name="files"
                    :show-upload-list="false"
                    :action="uploadFiles"
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :format="['mp3']"
                    :on-format-error="handleFormatError"
                    :max-size="uploadFilesMaxSize">
                    <Button>
                      <i class="iconfont">&#xe663;</i>
                      {{ $t('key1002407') }}
                    </Button>
                  </Upload>
                  <div class="files_name_box" v-if="containerModalForm.colorAudioPath">
                    <span class="text" :title="containerModalForm.colorAudioPath">{{ containerModalForm.colorAudioPath }}</span>
                    <Icon class="cursor" @click="deleteColorAudio" color="#C92308" size="17" type="md-close"/>
                  </div>
                </div>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="!editColorTalg">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="containerModalForm.ymsWarehouseId" filterable transfer>
                <Option v-for="(item, index) in ymsWarehouseList" :value="item.ymsWarehouseId" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="!editColorTalg">
            <Form-item :label="$t('key1001495')" prop="remarks">
              <Input type="textarea"
                :showWordLimit="true"
                :maxlength="50"
                :autosize="{ minRows: 4, maxRows: 6}"
                v-model.trim="containerModalForm.remarks">
              </Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="containerModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="containerModalBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDataSetBatchList, getEnableWarehouseData, getEnumList, getWarehouseName} from "@/utils/common";

export default {
  name: 'containerManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      total: 0,
      pageParams: {
        code: null,
        status: null,
        ymsContainerTypeId: null,
        colorNameList: [],
        ymsWarehouseIds: [],
        upDown: 'down',
        orderBy: 'updatedTime',
        pageNum: 1,
        pageSize: 15,
      },
      containerTypeList: [],
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002188'),
          key: 'type',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let obj = v.containerTypeList.filter(i => i.ymsContainerTypeId === params.row.ymsContainerTypeId);
            return h('span', obj.length ? obj[0].name : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002388'),
          key: 'color',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let backgroundColor = params.row.colorCode;
            let colorName = params.row.colorName || '-';
            return h('div', {class: 'flex justify-content-center align-items-center'}, [
              backgroundColor ? h('div', {
                style: {
                  width: '35px',
                  height: '20px',
                  backgroundColor: backgroundColor,
                  marginRight: '8px'
                }
              }) : '',
              h('span', colorName)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002389'),
          key: 'status',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = '-';
            v.jobStatusList.forEach((item) => {
              if (item.value === status) {
                text = status === 'null' ? '-' : item.title;
              }
            });
            return h('span', {
              class: status === 0 ? 'openStatus' : 'stopStatus'
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002391'),
          key: 'updatedTime',
          minWidth: 160,
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remarks',
          width: 250,
          align: 'center',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remarks, 250, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002240'),
                    show: v.getPermission('ymsContainer_printContainer'),
                    clickFn: () => {
                      v.printContainerSingle(params.row.ymsContainerId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002392'),
                    show: v.getPermission('ymsContainer_updateColor'),
                    clickFn: () => {
                      v.editColorTalg = true;
                      v.ymsContainerId = params.row.ymsContainerId;
                      v.containerTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002392');
                      let keyList = ['colorAudioPath', 'colorCode', 'colorName'];
                      let obj = params.row;
                      for (let key in obj) {
                        if (keyList.includes(key)) {
                          v.containerModalForm[key] = obj[key];
                        }
                      }
                      v.containerModal = true;
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsContainer_delete'),
                    clickFn: () => {
                      v.deleteContainer(params.row.ymsContainerId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      selectTableData: [],
      ruleValidate: {
        ymsContainerCount: [
          {
            required: true,
            validator: v.containerNumberCheck(),
            trigger: 'change'
          }
        ],
        ymsContainerTypeId: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002194'),
            trigger: 'change'
          }
        ],
        ymsWarehouseId: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002393'),
            trigger: 'change'
          }
        ]
      },
      containerModal: false,
      containerModalForm: {
        remarks: '',
        ymsContainerCount: 1,
        ymsContainerTypeId: '',
        ymsWarehouseId: '',
        colorCode: '',
        colorName: '',
        colorAudioPath: null,
      },
      containerColorList: [],
      uploadFiles: api.post_uploadFiles + '?basePath=yms-core-service&action="uploadimage"', // 上传音频
      editColorTalg: false,
      ymsContainerId: null,
      containerTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002394'),
      warehouseList: [],
      ymsWarehouseList: [],
      enumData: []
    };
  },
  computed: {
    // 作业状态
    jobStatusList() {
      const ENUM_KEY = 'YmsContainerStatusStatusCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = ['YmsContainerStatusStatusCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getEnableWarehouseData(1).then((data) => {
          v.warehouseList = data;
          v.ymsWarehouseList = data;
        });
        await this.getContainerColorData();
        await this.getYmsContainerTypeQuery();
        await this.getList();
      })();
    },
    // 获取容器类别
    getYmsContainerTypeQuery() {
      let v = this;
      return new Promise(resolve => {
        v.axios.get(api.get_ymsContainer_queryContainerTypeList).then(response => {
          if (response.data.code === 0) {
            v.containerTypeList = response.data.datas;
            resolve(response.data.datas);
          } else {
            resolve();
          }
        }).catch(() => {
          resolve();
        });
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainer_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainer_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 打开弹窗
    openContainer() {
      // 清空数据
      for (let key in this.containerModalForm) {
        this.containerModalForm[key] = '';
      }
      this.containerModalForm.ymsContainerCount = 1;
      this.containerTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002394');
      this.containerModal = true;
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 批量删除容器
    batchDeleteBtn() {
      let v = this;
      if (v.selectTableData.length === 0) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002395'));
        return;
      }
      v.isDelModal(() => {
        let params = v.selectTableData.map((i) => i.ymsContainerId);
        v.axios.delete(api.delete_ymsContainer_batchDelete, {
          data: params
        }).then((response) => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
            v.getList();
          }
        });
      });
    },
    deleteContainer(ymsContainerId) {
      let v = this;
      v.isDelModal(() => {
        v.axios.delete(api.delete_ymsContainer_query + ymsContainerId).then((response) => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
            v.getList();
          }
        });
      });
    },
    // 打印容器条码单个
    printContainerSingle(ymsContainerId) {
      let v = this;
      v.axios.put(api.put_ymsContainer_printContainer, [ymsContainerId], {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.commonPrint(data, '1');
        }
      });
    },
    // 批量打印容器条码
    printContainerBtn() {
      let v = this;
      if (v.selectTableData.length === 0) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002395'));
        return;
      }
      v.axios.put(api.put_ymsContainer_batchPrintContainer, v.selectTableData.map((i) => i.ymsContainerId),
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.commonPrint(data, '1');
          }
        }
      });
    },
    // 新增容器的确定按钮
    containerModalBtn() {
      let v = this;
      if (v.editColorTalg) {
        let query = {
          colorAudioPath: v.containerModalForm.colorAudioPath,
          colorCode: v.containerModalForm.colorCode,
          colorName: v.containerModalForm.colorName,
          ymsContainerId: v.ymsContainerId
        };
        v.axios.post(api.post_ymsContainer_updateColor, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.search();
            v.containerModal = false;
            v.getContainerColorData();
          }
        });
      } else {
        v.$refs['containerModalForm'].validate((valid) => {
          if (valid) {
            v.axios.post(api.post_ymsContainer_batchInsert, v.containerModalForm, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                v.search();
                v.containerModal = false;
                v.getContainerColorData();
              }
            });
          }
        });
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.getList();
    },
    // 校验容器数量
    containerNumberCheck() {
      let v = this;
      let reg = v.$regular.positiveInteger;
      return function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002396')));
        } else if (!reg.test(value)) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002397')));
        } else {
          callback();
        }
      };
    },
    // 监听容器弹窗
    containerChange(value) {
      if (!value) {
        this.$refs['containerModalForm'].resetFields();
        this.editColorTalg = false;
        this.ymsContainerId = null;
        this.containerModalForm.colorCode = '';
        this.containerModalForm.colorName = '';
        this.containerModalForm.colorAudioPath = null;
      }
    },
    // 上传音频之前
    beforeHandleUpload(file) {
      this.containerModalForm.colorAudioPath = file;
      return false;
    },
    // 上传音频失败
    uploadError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002398'));
      return false;
    },
    // 上传音频成功
    uploadSuccess(res, file, fileList) {
      let v = this;
      if (res.code === 0) {
        v.containerModalForm.colorAudioPath = res.datas[0];
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
      }
    },
    // 获取容器颜色的基础数据
    getContainerColorData() {
      let v = this;
      v.axios.get(api.get_ymsContainer_queryContainerColor).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            v.containerColorList = data.filter((item) => {
              if (item) {
                return item;
              }
            });
          }
        }
      });
    },
    // 移除音频文件
    deleteColorAudio() {
      this.containerModalForm.colorAudioPath = null;
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .containerModalStyle {
  .reset_label_style .ivu-form-item-label:before {
    display: none !important;
  }

  .upload_audio_box {
    min-width: 120px;
    display: flex;
    flex-direction: column;

    .ivu-upload, .ivu-btn {
      width: 100%;
    }

    .files_name_box {
      display: flex;
      align-items: center;
      margin-top: 5px;
      line-height: initial;
      height: initial;

      .text {
        display: inline-block;
        font-size: 12px;
        color: #2D8CF0;
        max-width: 95px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        margin-right: 5px;
      }

    }
  }
}
</style>
